module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logs"
  }, [_vm._m(0), _vm._v(" "), (!_vm.logs) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v("Loading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.logs) ? _c('div', {
    staticClass: "logs-card mdl-card mdl-shadow--2dp",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    staticClass: "logs-list"
  }, [_c('ul', _vm._l((_vm.logs), function(log) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'log',
          params: {
            logId: log.logId
          }
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.formatTime(log.date)))]), _vm._v(":\n              "), _c('span', [_vm._v(_vm._s(log.ip))])])], 1)
  }))])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("logs")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e75e37c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logs.vue
// module id = 424
// module chunks = 1